(ns frontend.actions.tenant
  (:require
   [promesa.core :as p]
   [frontend.conn :as conn]
   [common.util :as cu]))


(defn *->create-custom-field
  [data on-success! on-error!]
  (-> (conn/sendp! :tenant/create-custom-field
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->set-image!
  [tenant-id attribute url on-success! on-error!]
  (-> (conn/sendp! :tenant/set-image
                   {:tenant-id tenant-id
                    :attribute attribute
                    :url       url})
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->update!
  [tenant-id attribute value on-success! on-error!]
  (-> (conn/sendp! :tenant/update
                   {:db/id    tenant-id
                    attribute value})
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->update-preference!
  [kw value on-success! on-error!]
  (-> (conn/sendp! :tenant/update-preferences
                   {:kw kw
                    :value value})
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->tokens
  [msg on-success! on-error!]
  (-> (conn/sendp! :tenant/tokens
                   msg)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->set-field-settings
  [{:keys [pipeline-id
           pipeline-settings]
    :as   args}
   on-success! on-error!]
  (-> (conn/sendp!
       :tenant/set-field-settings
       (cu/remove-nil-vals (merge {:tenant/field-configurations (:tenant/field-configurations args)}
                                  (when-let [blacklisted (:tenant/blacklisted-fields args)]
                                    {:tenant/blacklisted-fields (set blacklisted)})
                                  (when-let [whitelisted (:tenant/whitelisted-custom-fields args)]
                                    {:tenant/whitelisted-custom-fields (set whitelisted)})
                                  (when pipeline-id
                                    {:pipeline-id       pipeline-id
                                     :pipeline/settings pipeline-settings}))))
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->api-tokens
  [msg on-success! on-error!]
  (-> (conn/sendp! :tenant/get-api-tokens
                   msg)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->update-api-token!
  [msg on-success! on-error!]
  (-> (conn/sendp! :tenant/update-api-token!
                   msg)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->rotate-api-token!
  [msg on-success! on-error!]
  (-> (conn/sendp! :tenant/rotate-api-token!
                   msg)
      (p/then on-success!)
      (p/catch on-error!)))


(defn *->revoke-api-token!
  [msg on-success! on-error!]
  (-> (conn/sendp! :tenant/revoke-api-token!
                   msg)
      (p/then on-success!)
      (p/catch on-error!)))
